<template>
    <fade-transition :duration="{enter: 500, leave: 10}" mode="out-in" appear>
        <router-view></router-view>
    </fade-transition>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import {menusMixin} from "../mixins/menus";
    import {menusNames as mn,} from "../constants/menus";
    import {stateValidator} from "../mixins/routes/featured";

    export default {
        mixins: [stateValidator, menusMixin],
        computed: {
            ...mapGetters('featured', [
                'reel',
                'media',
            ])
        },
        created() {
            //console.log('created: featured')
            this.onRefresh()
        },
        mounted() {
            this.setSeo(this.$_getMenuSeo(mn.FEATURED_WORK))
        },
        watch: {
            '$route': 'onRefresh'
        },
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            onRefresh() {
                //console.log('refresh: featured.vue')
                this.$store.dispatch('featured/initFeatureState', this.$route.params)
                this.$_redirectIfFail()
                this.$scrollTo('body')
            },
        }
    }
</script>
